const MUX_STREAMING_DOMAIN = 'https://stream.mux.com';

const MUX_IMAGE_DOMAIN = 'https://image.mux.com';

export const MUX_KEY = 'd95959db-9062-413e-836d-5ab5f42e80f9';

export const getStreamingUrlForVideo = ({muxPlaybackId}) => muxPlaybackId ? `${MUX_STREAMING_DOMAIN}/${muxPlaybackId}.m3u8` : '';

export const getImageForVideo = ({muxPlaybackId}, params = {}) => {
    if (!muxPlaybackId) {
        return '';
    }
    if (!params.fit_mode) {
        params.fit_mode = params.width && params.height ? 'smartcrop' : 'crop';
    }
    const query = Object.keys(params).map(key => key + '=' + params[key]).join('&');
    return `${MUX_IMAGE_DOMAIN}/${muxPlaybackId}/thumbnail.jpg?${query}`;
};

/**
 * Resolves once a Mux asset has finished processing and is ready for playback.
 *
 * When a Mux asset is still "preparing", both the HLS stream and the thumbnail
 * endpoint respond with a 412 – and mux-video errors out on that without ever
 * retrying. The thumbnail flips to a 200 at the same moment playback becomes
 * ready, so we probe it with an <img> (which needs no CORS) and keep retrying,
 * backing off, until it loads.
 *
 * @param {{muxPlaybackId: string}} video
 * @param {{signal?: AbortSignal, interval?: number, maxInterval?: number}} options
 * @returns {Promise<void>}
 */
export const whenVideoReady = ({ muxPlaybackId }, { signal, interval = 3000, maxInterval = 15000 } = {}) => {
    return new Promise((resolve, reject) => {

        if (!muxPlaybackId) {
            reject(new Error('Missing Mux playback ID'));
            return;
        }

        let attempt = 0;
        let timeout = null;

        const cleanup = () => {
            if (timeout) {
                clearTimeout(timeout);
            }
            if (signal) {
                signal.removeEventListener('abort', onAbort);
            }
        };

        const onAbort = () => {
            cleanup();
            reject(new DOMException('Aborted', 'AbortError'));
        };

        if (signal) {
            if (signal.aborted) {
                onAbort();
                return;
            }
            signal.addEventListener('abort', onAbort);
        }

        const probe = () => {
            const img = new Image();
            img.onload = () => {
                cleanup();
                resolve();
            };
            img.onerror = () => {
                attempt += 1;
                const delay = Math.min(interval * attempt, maxInterval);
                timeout = setTimeout(probe, delay);
            };
            // Small thumbnail + cache-buster so the browser doesn't serve a cached 412
            img.src = `${getImageForVideo({ muxPlaybackId }, { width: 16, height: 16 })}&_=${attempt}`;
        };

        probe();

    });
};
